import WeakDefaultMap from "../mem/weak-default-map";
import mfac from "../material-factory";
import { FloorViewConfig } from "./views-config";
import { Mesh, MeshStandardMaterial, Object3D, PlaneGeometry, Vector2 } from "three";
import { QUARTER_TURN } from "../math/constants";
import { Material, Room } from "../domain";
import { uvScale } from "../IIID";
import ReadySignal from "../control-flow/ready-signal";

const FLOOR_UV_SCALE = new Vector2(20, 20);

export class FloorView extends Object3D {
    mesh: Mesh;
    onReady = new ReadySignal('FloorView');
}


const cache = new WeakDefaultMap<Room, FloorView>(() => {
    const view = new FloorView();
    view.name = 'FloorView';

    view.mesh = new Mesh(new PlaneGeometry(1000, 1000), new MeshStandardMaterial());
    view.mesh.name = 'Floor Plane';

    // no need for the floor to cast as shadow
    view.mesh.receiveShadow = true;
    view.mesh.rotation.set(-QUARTER_TURN, 0, QUARTER_TURN);

    uvScale(view.mesh.geometry, FLOOR_UV_SCALE);

    view.add(view.mesh);

    return view;
});

export const get = cache.get;

export const update = (room: Room, config: FloorViewConfig) => {
    const view = get(room);
    view.mesh.material = mfac.makefrom(Material.fromJSON(config.material));
    view.onReady.trigger();
}
